import { configQuery } from '@gig/magic-common';
import { AFFILIATE_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';

var utmTypes;
(function (utmTypes) {
    utmTypes["UTM_AGENT"] = "utm_agent";
    utmTypes["UTM_CAMPAIGN"] = "utm_campaign";
    utmTypes["UTM_CONTENT"] = "utm_content";
    utmTypes["UTM_MEDIUM"] = "utm_medium";
    utmTypes["UTM_PAYLOAD"] = "utm_payload";
    utmTypes["UTM_SOURCE"] = "utm_source";
    utmTypes["UTM_TERM"] = "utm_term";
})(utmTypes || (utmTypes = {}));
var AffiliateService = /** @class */ (function () {
    function AffiliateService(cookie) {
        this.cookie = cookie;
        this.utm = {
            utm_agent: '',
            utm_campaign: '',
            utm_content: '',
            utm_medium: '',
            utm_payload: '',
            utm_source: '',
            utm_term: '',
        };
        this.utmParamsExpireDays = 7;
        this.bannerTagExpireDays = 30;
        this.registerAffiliateQuery();
        this.getConfigUtmParamsExpireDays();
        this.getConfigBannerTagExpireDays();
    }
    AffiliateService.prototype.getAffiliateTag = function () {
        return this.cookie.read('btag');
    };
    AffiliateService.prototype.getUtmParams = function () {
        var hasUtmParamsValue = Object.values(this.utm).some(function (value) { return value && value.length > 0; });
        // if user went with UTM params and immidiately(!) called the Sign Up pop-up
        // new UTM params have a bigger priority then saved in Cookie
        if (hasUtmParamsValue) {
            return this.utm;
        }
        else {
            var utmParamsCookie = this.cookie.read('utmParams');
            // if user went with UTM params, but went to some pages and then(!) called the Sign Up pop-up
            if (utmParamsCookie) {
                return JSON.parse(utmParamsCookie);
            }
            else {
                // if the utmParams cookie doesn't exist for some reason,
                // return an empty utm params for backward compatibility with sing-up/v2 pages and APIs
                return this.utm;
            }
        }
    };
    AffiliateService.prototype.getConfigUtmParamsExpireDays = function () {
        return __awaiter(this, void 0, void 0, function () {
            var utmConfigData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('utmParamsExpireDays')];
                    case 1:
                        utmConfigData = _a.sent();
                        if (typeof utmConfigData === 'number' && utmConfigData > 0) {
                            this.utmParamsExpireDays = utmConfigData;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AffiliateService.prototype.getConfigBannerTagExpireDays = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bannerTagConfigData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('bannerTagExpireDays')];
                    case 1:
                        bannerTagConfigData = _a.sent();
                        if (typeof bannerTagConfigData === 'number' &&
                            bannerTagConfigData > 0) {
                            this.bannerTagExpireDays = bannerTagConfigData;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AffiliateService.prototype.setAffiliate = function (btag) {
        var date = new Date();
        date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * this.bannerTagExpireDays);
        this.cookie.write('btag', btag, { expires: date });
        this.affiliateTag = btag;
    };
    AffiliateService.prototype.setUtmParamsCookie = function () {
        var hasUtmParamsValue = Object.values(this.utm).some(function (value) { return value && value.length > 0; });
        if (hasUtmParamsValue) {
            var date = new Date();
            date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * this.utmParamsExpireDays);
            this.cookie.write('utmParams', JSON.stringify(this.utm), {
                expires: date,
            });
        }
    };
    AffiliateService.prototype.prepareUtmParams = function (utm, to) {
        switch (to) {
            case utmTypes.UTM_AGENT:
                this.utm.utm_agent = utm;
                break;
            case utmTypes.UTM_CAMPAIGN:
                this.utm.utm_campaign = utm;
                break;
            case utmTypes.UTM_CONTENT:
                this.utm.utm_content = utm;
                break;
            case utmTypes.UTM_MEDIUM:
                this.utm.utm_medium = utm;
                break;
            case utmTypes.UTM_PAYLOAD:
                this.utm.utm_payload = utm;
                break;
            case utmTypes.UTM_SOURCE:
                this.utm.utm_source = utm;
                break;
            case utmTypes.UTM_TERM:
                this.utm.utm_term = utm;
                break;
            default:
                return '';
        }
    };
    AffiliateService.prototype.registerAffiliateQuery = function () {
        var _this = this;
        window.queryBus.subscribe(AFFILIATE_QUERY, function () {
            return _this.affiliateTag;
        });
    };
    return AffiliateService;
}());

export { AffiliateService };
